import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {Paper, Typography, Button} from "@material-ui/core";
import {keys} from "@material-ui/core/styles/createBreakpoints";
import {IParcela} from "../../../types";
import moment from "moment";
import * as XLSX from "xlsx";

const texts = require('../../../texts/riegoneto.json')

interface IProps {
    setSector(sector: string): void
    riego: Record<string, Record<string, number>>
    metodo: string
    sector: string
    parcelas: IParcela[]
    parcela: string
    idioma: string
}

interface IState {
    vertical: boolean
    cambiando: boolean
    parcela: IParcela
    dia_inicio: string
    dia_fin: string
    text: Record<string, string>
}


class TablaRiego extends React.Component<IProps, IState> {
    state: IState = {
        vertical: window.matchMedia("(orientation: portrait)").matches,
        cambiando: false,
        parcela: {} as IParcela,
        dia_inicio: '',
        dia_fin: '',
        text: texts[this.props.idioma]
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        if (this.state.parcela.id !== "demo" && nextState.parcela.id === "demo") {
            this.setState({
                dia_inicio: "23/08/2021",
                dia_fin: "29/08/2021"
            })
        }
        return true
    }

    componentDidMount() {
        let parcela: IParcela = {}
        for (const element of this.props.parcelas) {
            if (element.id === this.props.parcela) {
                parcela = element
                this.setState({parcela: element})
                break
            }
        }

        const dias = parcela.dias.split(',')

        const hoy = (((new Date()).getDay() - 1) + 7) % 7
        let inicio = 0
        let final = 0

        for (let i = 0; i < 7; i++) {
            if (parseInt(dias[(hoy - i + 7) % 7]) === 1) {
                inicio = i
                break
            }
        }

        for (let i = 1; i < 8; i++) {
            if (parseInt(dias[(hoy + i + 7) % 7]) === 1) {
                final = i
                break
            }
        }

        const dia_inicio = moment(new Date(new Date().setDate(new Date().getDate()-inicio+1))).format('DD/MM/YYYY')
        const dia_fin = moment(new Date(new Date().setDate(new Date().getDate()+final))).format('DD/MM/YYYY')

        if (this.state.parcela.id !== "demo") {
            this.setState({
                dia_inicio: dia_inicio,
                dia_fin: dia_fin
            })
        } else {
            this.setState({
                dia_inicio: "23/08/2021",
                dia_fin: "29/08/2021"
            })
        }
    }

    convertToCSV = (objArray: any) => {
        const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
        let str = '';

        for (let i = 0; i < array.length; i++) {
            let line = '';
            for (const index in array[i]) {
                if (line !== '') line += ';'
                if (array[i].hasOwnProperty(index)) line += array[i][index]
            }
            str += line + '\r\n';
        }

        return str;
    }

    handleDownload = () => {

        const data: Record<string, string|number>[] = []

        for (const k of Object.keys(this.props.riego[this.props.metodo])) {

            let obj = {} as Record<string, string|number>
            obj[this.state.text["12"]] = k
            obj[this.state.text["13"]] = (Math.round(this.props.riego[this.props.metodo][k]*100)/100).toString().replace('.' ,',')
            obj[this.state.text["14"]] = (Math.round(this.props.riego['area'][k])).toString().replace('.' ,',')

            data.push(obj)
        }
        let obj = {} as Record<string, string|number>
        obj[this.state.text["12"]] = ""
        data.push(obj)
        obj = {}
        obj[this.state.text["12"]] = this.state.text["9"] + ' ' + this.props.metodo
        data.push(obj)
        obj = {}
        obj[this.state.text["12"]] = this.state.text["10"] + " " + new Date().toLocaleDateString('es') + ' ' + this.state.text["11"] + ' ' + new Date((new Date()).setDate((new Date()).getDate() + 6)).toLocaleDateString('es')
        data.push(obj)


        const worksheet = XLSX.utils.json_to_sheet(data);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Page1");
        XLSX.writeFile(workbook, this.state.text["15"]+'_' + this.props.metodo + '.xlsx');


        // const jsonObject = JSON.stringify(data);
        // const csv = this.convertToCSV(jsonObject);

        // const exportedFilenmae = this.state.text["15"]+'_' + this.props.metodo + '.csv';
        // const blob = new Blob([excel], { type: 'application/vnd.ms-excel' });
        // if (navigator.msSaveBlob) {
        //     navigator.msSaveBlob(blob, exportedFilenmae);
        // } else {
        //     var link = document.createElement("a");
        //     if (link.download !== undefined) {
        //         var url = URL.createObjectURL(blob);
        //         link.setAttribute("href", url);
        //         link.setAttribute("download", exportedFilenmae);
        //         link.style.visibility = 'hidden';
        //         document.body.appendChild(link);
        //         link.click();
        //         document.body.removeChild(link);
        //     }
        // }
    }

    getColor = (k: string) => {
        let cnt = 0
        for (const el of Object.keys(this.props.riego[this.props.metodo])) {
            cnt += 1
            if (el === k) break
        }
        if (cnt%2 === 0) return '#fff'
        else return '#eee'
    }

    render () {
        const doOnOrientationChange = () => {
            if (!this.state.cambiando) {
                this.setState({cambiando: true, vertical: !this.state.vertical})
                setTimeout(() => this.setState({cambiando: false}), 100)
            }
        }

        window.addEventListener("orientationchange", function() {
            doOnOrientationChange()
        }, false);
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    height: "fit-content",
                    marginTop: this.state.vertical? 20 : 0
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <Paper
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: 20,
                        width: '100%'
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            width: '90%',
                            height: 80,
                            justifyContent: "space-between",
                            alignItems: "center",
                            alignSelf: "center"
                        }}
                    >

                        <Typography
                            style={{
                                fontWeight: "bold",
                                fontSize: 18,
                                fontFamily: "Poppins"
                            }}
                        >
                            {this.state.text["17"]} {this.state.dia_inicio} {this.state.text["18"]} {this.state.dia_fin}
                        </Typography>

                        <Button
                            variant={"contained"}
                            style={{
                                backgroundColor:'#80ED99',
                                width: "fit-content",
                                textTransform: 'none',
                                borderRadius: 10,
                                marginTop: 10
                            }}
                            onClick={() => this.handleDownload()}
                        >
                            <Typography
                                style={{
                                    fontWeight: "bold",
                                    fontFamily: "Poppins"
                                }}
                            >
                                {this.state.text["19"]}
                            </Typography>
                        </Button>

                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            width: '100%'
                        }}
                    >
                        <div style={{width: '30%'}}>
                            <Typography
                                style={{fontWeight: "bold", marginLeft: 30, fontFamily: "Poppins"}}
                            >
                                {this.state.text["20"]}
                            </Typography>
                        </div>
                        <div style={{width: '15%'}}>
                            <Typography
                                style={{fontWeight: "bold" , fontFamily: "Poppins"}}
                            >
                                {this.state.text["21"]} ({this.state.text[this.props.metodo]})
                            </Typography>
                        </div>
                        <div style={{width: '20%'}}/>
                        <div style={{width: '15%'}}>
                            <Typography
                                style={{fontWeight: "bold", fontFamily: "Poppins"}}
                            >
                                {this.state.text["22"]}
                            </Typography>
                        </div>
                        <div style={{width: '20%'}}/>
                    </div>

                    {Object.keys(this.props.riego[this.props.metodo]).map(k =>
                        <div
                            key={k}
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: '100%',
                                backgroundColor: k === this.props.sector? '#80ED99' : this.getColor(k),
                                cursor: "pointer"
                            }}
                            onClick={() => this.props.setSector(k)}
                        >
                            <div style={{width: '30%'}}>
                                <Typography style={{marginLeft: 30, fontFamily: "Poppins"}}>
                                    {k}
                                </Typography>
                            </div>
                            <div style={{width: '15%'}}>
                                <Typography style={{fontFamily: "Poppins"}}>
                                    {Math.round(this.props.riego[this.props.metodo][k]*100)/100}
                                </Typography>
                            </div>
                            <div style={{width: '20%'}}>
                                <Typography style={{fontFamily: "Poppins"}}>
                                    m³
                                </Typography>
                            </div>
                            <div style={{width: '15%'}}>
                                <Typography style={{fontFamily: "Poppins"}}>
                                    {Math.round(this.props.riego['area'][k]/100)/100 < 0.1?
                                        Math.round(this.props.riego['area'][k])
                                        :
                                        Math.round(this.props.riego['area'][k]/100)/100
                                    }
                                </Typography>
                            </div>
                            <div style={{width: '20%'}}>
                                <Typography style={{fontFamily: "Poppins"}}>
                                    {Math.round(this.props.riego['area'][k]/100)/100 < 0.1?
                                        'm²'
                                        :
                                        'Ha'
                                    }
                                </Typography>
                            </div>
                        </div>
                    )}
                    <div style={{width: '100%', height: 20}}/>

                </Paper>

            </div>
        )
    }
}


const mapStateToProps = (state: IStore) => ({
    riego: state.riego.riego,
    metodo: state.riego.metodo,
    sector: state.riego.sector,
    parcelas: state.principal.parcelas,
    parcela: state.navegacion.parcela,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setSector: (sector: string) => dispatch({type: "set-riego-sector", sector})
});

export default connect(mapStateToProps, mapDispatchToProps)(TablaRiego);
